module.exports = __webpack_public_path__ + "img/meal-default.f119ebfd.svg";